$(document).ready(function(){  
  $(".return-btn button").on('click', function() {

      	if(history.length > 1 && document.referrer != ""){
			window.history.back();
        } else {
         	location.href = "https://stonecandlerush.com/pages/collection"; 
        }

  });
});


$('a.build-your-own-brand').click(function(e) {
  if (this.hostname && this.hostname == 'light4lifecause.com') {
    if (!confirm("You are leaving our site. Do you want to proceed?")) {
      e.preventDefault(); // Stops navigation
    }
  }
});


// For price per lb column in Natural Coconut Apricot Wax product
if(ShopifyAnalytics.meta.product.handle == 'coconut-wax-slab-11oz') {
  var checkExist = setInterval(function() {   
      // Check if the element has finally loaded
      if ($('.omg-table').length > 0) {
        $('.omg-table tr').eq(0).find('th').eq(2).before('<th>Price per lb</th>');
        $('.omg-table tr').eq(1).find('td').eq(2).before('<td>$3.25</td>');
        $('.omg-table tr').eq(2).find('td').eq(2).before('<td>$2.88</td>');

        // Stop the interval from running anymore
        clearInterval(checkExist);
      }
      
  }, 100)
}